import { MDCTopAppBar } from '@material/top-app-bar'

export default {
  setup() {
    this.topAppBar = new MDCTopAppBar(this.el)
  },
  destroy() {
    this.topAppBar?.destroy()
    this.topAppBar = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
